import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['mobilePhone', 'secondFactor', 'authySecondFactor', 'secondFactorPrompt', 'submit']

  connect() {
    this.previousMobilePhonePresent = this.hasMobilePhone()
    this.syncAuthyAvailability()

    if (!this.previousMobilePhonePresent && !this.hasSelectedSecondFactor()) {
      this.defaultToAuthenticatorApp()
    }

    this.syncFormState()
  }

  sync() {
    this.syncFormState()
  }

  mobilePhoneChanged() {
    const mobilePhonePresent = this.hasMobilePhone()

    if (!this.previousMobilePhonePresent && mobilePhonePresent) {
      this.secondFactorTargets.forEach((radio) => {
        radio.checked = false
      })
    }

    this.syncAuthyAvailability()

    if (!mobilePhonePresent && !this.hasSelectedSecondFactor()) {
      this.defaultToAuthenticatorApp()
    }

    this.previousMobilePhonePresent = mobilePhonePresent
    this.syncFormState()
  }

  hasMobilePhone() {
    return this.mobilePhoneTarget.value.trim().length > 0
  }

  hasUsableMobilePhone() {
    const digits = this.mobilePhoneTarget.value.replace(/\D/g, '')
    return digits.length === 10 || (digits.length === 11 && digits.startsWith('1'))
  }

  hasSelectedSecondFactor() {
    return this.secondFactorTargets.some((radio) => radio.checked)
  }

  syncAuthyAvailability() {
    const authyAvailable = this.hasUsableMobilePhone()
    this.authySecondFactorTarget.disabled = !authyAvailable

    if (!authyAvailable && this.authySecondFactorTarget.checked) {
      this.authySecondFactorTarget.checked = false
    }
  }

  syncFormState() {
    const missingSecondFactor = !this.hasSelectedSecondFactor()
    this.submitTarget.disabled = !this.element.checkValidity() || this.hasPasswordMismatch()

    if (this.hasSecondFactorPromptTarget) {
      this.secondFactorPromptTarget.classList.toggle('text-danger', missingSecondFactor)
      this.secondFactorPromptTarget.classList.toggle('font-weight-bold', missingSecondFactor)
      this.secondFactorPromptTarget.classList.toggle('d-none', !missingSecondFactor)
    }
  }

  hasPasswordMismatch() {
    const password = this.element.querySelector('input[name$="[password]"]')
    const confirmation = this.element.querySelector('input[name$="[password_confirmation]"]')

    return password &&
      confirmation &&
      password.value.length > 0 &&
      confirmation.value.length > 0 &&
      password.value !== confirmation.value
  }

  defaultToAuthenticatorApp() {
    const authenticatorApp = this.secondFactorTargets.find((radio) => radio.value === 'totp')
    if (authenticatorApp) {
      authenticatorApp.checked = true
    }
  }
}
